import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    overflowX1080: {
        // eslint-disable-next-line
        overflowX: 'auto !important',
    },
    overflowX640: {
        // eslint-disable-next-line
        ['@media (max-width:640px)']: {
            overflowX: 'auto',
        },
    },
    flexGrid: {
        display: 'flex',
        // justifyContent: 'space-between',
    },
    paper: {
        width: '100%',
        boxShadow: 'unset',
        marginTop: '10px',
        '& > div': {
            width: '100% !important',
        },
    },
    assetZones: {
        width: '35%',
        maxWidth: '35%',
        // minWidth: '360px',
        // maxWidth: '460px',
        '& .ReactVirtualized__Table__Grid': {
            backgroundColor: '#fafafa',
        },
    },
    zoneItems: {
        width: '65%',
        maxWidth: '65%',
        marginTop: '10px',
    },
    popupActionContainer: {
        display: 'flex',
        alignItems: 'center',
        color: '#7E8C8D',
        padding: '10px',
        fontSize: '14px',
        '&:hover': {
            cursor: 'pointer',
            transform: 'scale(1.05)',
        },
    },
    popupActionIcon: {
        display: 'flex',
        justifyContent: 'center',
        '& svg': {
            height: '20px',
            width: '20px',
        },
    },
    itemsAutoSizerWrapper: {
        minWidth: '520px !important',
    },
    zoneTableButton: {
        backgroundColor: (props) => props.colors.button.secondaryBackground,
        color: (props) => props.colors.button.secondaryForeground,
        border: '0px',
        padding: '6px',
        borderRadius: '5px',
        fontSize: '12px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        '&:disabled': {
            backgroundColor: (props) => props.colors.button.secondaryBackground,
            color: (props) => props.colors.button.secondaryForeground,
            filter: 'brightness(50%)',
        },
        '&:hover': {
            backgroundColor: (props) => props.colors.button.secondaryBackground,
            color: (props) => props.colors.button.secondaryForeground,
            filter: 'brightness(90%)',
        },
    },
    addNewIcon: {
        padding: '8px !important',
        borderRadius: '25px !important',
        background: (props) => `${props.colors.button.primaryBackground} !important`,
        color: (props) => `${props.colors.button.primaryForeground} !important`,
    },
}));
